// removed by extract-text-webpack-plugin
module.exports = {"sendEmailButtons":"_3bxpAk4HTmxafZjyyOYySl","sendEmailButton":"_2Ye3YR-UZlSeVoAak0Pe2H","remindersHint":"_1dlbgPXLEdTWLni8Cc-vVU","addOption":"_1LC3cHYhGuw-D3dRRuERXl","csvHint":"_2SzQoKgNK_2vOZD91bBjAH","remindersRadios":"_1T2bcsjTHxZTxmO6_o5_tm","reminderRadio":"_1Gn1CvWhe_D0sW5gvQtGM9","reminderText":"_1_EJTeLwY43r1u5wFds63v","reminderHint":"LKUAXOJKGGqFNO7M2da4T"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectRecipients/ProjectRecipients.scss
// module id = 1369
// module chunks = 1